export default __webpack_public_path__ + "static/media/paratyphi-synthetic-template-design-ptyphi-lamp--grna-sequence.57780061.pdf";